import React, {Component} from "react";

import {InputButton, SubmitButton} from "../../../../../components/boda-boda/Forms";
import {merchantBranchAPI} from "../../../../../config/boda-boda/apiUrls.config";
import {apiResponseStoringType} from "../../../../../config/boda-boda/apiResponseKey";
import {ModalUI} from "../../../../../components/boda-boda/Modal/ModalUI";

class DeleteUI extends Component {
    constructor(props) {
        super(props);
        this.state = { isShow: false };
    }

    render() {

        const onClickFn = () => {
            this.setState({ isShow: true })
        };

        return (
            <React.Fragment>
                <InputButton
                    elementWrapperStyle={"mr-2"}
                    startIcon={"fas fa-window-close"}
                    elementStyle={"btn btn-danger  waves-effect waves-light"}
                    btnText={"Delete"}
                    onClickBtnFn={() => onClickFn()}
                />

                <ModalUI
                    isOpen={this.state.isShow}
                    modalTitle={"Please Confirm"}
                    modalBodyComponent={<p>Are you sure you want to delete this merchant?</p>}
                    showHideToggleFn={() => this.setState({ isShow: false })}
                    modalFooterComponent={
                        <DeleteBtn
                            historyFn={this.props.historyFn}
                            merchantBranch={this.props.merchantBranch}
                            merchant={this.props.merchant}
                        />
                    }
                />
            </React.Fragment>
        )
    }
}

const DeleteBtn = (props) => {
    return (
        <SubmitButton
            btnText={"Delete"}
            elementStyle={"btn btn-danger  waves-effect waves-light"}
            flashMessages={{
                "success": {
                    status: true,
                    message: "Merchant Branch has successfully deleted",
                    type: "success"
                }
            }}
            callApiObject={{
                isSetHeaders: true,
                multipart: false,
                method: "delete",
                onUpload: false
            }}
            apiDataStoringObject={{
                setLoader: true,
                storingType: apiResponseStoringType.apiRequestOnly,
                mergeToSuccessResponse: null,
                mergeToErrorResponse: null,
            }}
            onGetAPIEndPointFn={(formObject) => {
                return {
                    url: `${merchantBranchAPI.url}/${props.merchantBranch}`,
                    key: merchantBranchAPI.key
                }
            }}
            onResponseCallBackFn={(error, result) => {
                if (!error) {
                    props.historyFn.push(`/merchant/${props.merchant}/branch`);
                }
            }}
        />
    )
}

const RemoveMessage = () => {
    return(
        <p>Are your sure you want to delete this item?</p>
    );
}

const RemoveBtn = (props) => {
    return(
        <SubmitButton
            btnText={"Delete"}
            elementStyle={"btn btn-danger  waves-effect waves-light"}
            dataTableKey={merchantBranchAPI.key}
            callApiObject={{
                isSetHeaders: true,
                multipart: false,
                method: "delete",
                onUpload: false
            }}
            apiDataStoringObject={{
                setLoader: true,
                storingType: apiResponseStoringType.dateTableLinkedForm,
                mergeToSuccessResponse: null,
                mergeToErrorResponse: null,
            }}
            onGetAPIEndPointFn={(formObject) => {
                return {
                    url: `${merchantBranchAPI.url}/${props.row.id}`,
                    key: merchantBranchAPI.key
                }
            }}
            onResponseCallBackFn={(error, result) => {
                if (!error) {
                    props.setModelStatusFn(false);
                }
            }}
        />
    );
}

export {
    RemoveBtn,
    RemoveMessage,
    DeleteUI,
    DeleteBtn
}
